// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3":"b33306aa","182":"c917689a","767":"ef72398b"}[chunkId] + ".chunk.css";
};